(function () {
  // MRT Stations hub: sticky-nav scroll-spy (same scrollTop approach as
  // assets/hdb-nav.js, ported) + a plain substring search over .mrt-hub
  // station cards. One file covers both since they share the same root.
  function init(nav) {
    if (!nav || nav.dataset.navInit) return;
    nav.dataset.navInit = '1';
    var links = [].slice.call(nav.querySelectorAll('a[href^="#"]'));
    var targets = links.map(function (a) {
      var id = a.getAttribute('href').slice(1);
      return document.getElementById(id);
    });
    var lastActive = -1;
    function onScroll() {
      var y = window.scrollY + nav.offsetHeight + 40;
      var activeIdx = 0;
      targets.forEach(function (t, i) {
        if (t && t.offsetTop <= y) activeIdx = i;
      });
      links.forEach(function (a, i) {
        a.classList.toggle('on', i === activeIdx);
      });
      if (activeIdx !== lastActive) {
        lastActive = activeIdx;
        var activeLink = links[activeIdx];
        if (activeLink) activeLink.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    var input = nav.querySelector('[data-mrthub-search]');
    if (!input) return;
    var cards = [].slice.call(document.querySelectorAll('[data-mrthub-card]'));
    var groups = [].slice.call(document.querySelectorAll('[data-mrthub-line-group]'));
    var noMatch = document.querySelector('[data-mrthub-no-match]');
    input.addEventListener('input', function () {
      var q = input.value.trim().toLowerCase();
      var anyVisible = false;
      cards.forEach(function (card) {
        var match = !q || (card.dataset.name || '').indexOf(q) !== -1;
        card.hidden = !match;
        if (match) anyVisible = true;
      });
      groups.forEach(function (group) {
        var hasVisible = [].slice.call(group.querySelectorAll('[data-mrthub-card]')).some(function (c) { return !c.hidden; });
        group.hidden = !hasVisible;
      });
      if (noMatch) noMatch.hidden = anyVisible || !q;
    });
  }
  function all() {
    [].forEach.call(document.querySelectorAll('[data-mrthub-nav]'), init);
  }
  if (document.readyState !== 'loading') all();
  else document.addEventListener('DOMContentLoaded', all);
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-mrthub-nav]');
    if (el) {
      el.dataset.navInit = '';
      init(el);
    }
  });
})();
